import React, { useEffect, useState } from 'react';
export function FinalCtaSection() {
  const [timeLeft, setTimeLeft] = useState(8 * 3600 + 9 * 60 + 32);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const days = Math.floor(timeLeft / 86400);
  const hours = Math.floor(timeLeft % 86400 / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="w-full" data-id="element-92">
      {/* Green top section */}
      <div className="bg-[#2d5a1e] px-4 md:px-8 pt-16 pb-8" data-id="element-93">
        <div className="max-w-[800px] mx-auto text-center" data-id="element-94">
          <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-[42px] font-bold text-white leading-tight mb-3" data-id="element-95">
            Última Llamada para Cambiar tu Año
          </h2>
          <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-96"></div>
          <p className="font-['Montserrat',_sans-serif] text-[#d4e8d0] text-base md:text-lg mb-10" data-id="element-97">
            Dejá de postergar. Tenés las herramientas, el sistema y la garantía.
            <br data-id="element-98" />
            Solo falta tu decisión.
          </p>
        </div>
      </div>

      {/* Product Image */}
      <div className="bg-[#2d5a1e] px-0" data-id="element-99">
        <div className="max-w-[800px] mx-auto" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/pGwbTdaNpQ87wgA7t1rRzw/Captura_de_pantalla_2026-04-30_a_las_9.02.10_p._m..png" alt="Viandas Rentables - Sistema completo" className="w-full h-auto object-cover" data-id="element-101" />
        </div>
      </div>

      {/* Pricing Card */}
      <div className="bg-[#2d5a1e] px-4 md:px-8 pt-8 pb-8" data-id="element-102">
        <div className="max-w-[500px] mx-auto" data-id="element-103">
          <style data-id="element-104">
            {`
              @keyframes shimmerFinal {
                0% { background-position: -200% 0; }
                100% { background-position: 200% 0; }
              }
              .final-pricing-glow {
                position: relative;
                border: 2px solid rgba(250, 204, 21, 0.4);
                box-shadow: 0 0 20px rgba(250, 204, 21, 0.15), 0 0 40px rgba(250, 204, 21, 0.08), inset 0 0 20px rgba(250, 204, 21, 0.05);
              }
              .final-pricing-glow::before {
                content: '';
                position: absolute;
                inset: -2px;
                border-radius: 1rem;
                padding: 2px;
                background: linear-gradient(90deg, transparent, rgba(250,204,21,0.4), transparent);
                background-size: 200% 100%;
                animation: shimmerFinal 3s linear infinite;
                -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                -webkit-mask-composite: xor;
                mask-composite: exclude;
                pointer-events: none;
              }
              @keyframes pulseScaleFinal {
                0%, 100% { transform: scale(1); }
                50% { transform: scale(1.05); }
              }
              .animate-pulse-scale-final {
                animation: pulseScaleFinal 1.5s ease-in-out infinite;
              }
            `}
          </style>
          <div className="final-pricing-glow bg-[#232a3b] rounded-2xl p-8 md:p-10 text-center" data-id="element-105">
            <p className="font-['Montserrat',_sans-serif] text-[#888] text-lg line-through mb-1" data-id="element-106">
              $89.900 ARS
            </p>
            <p className="font-['Playfair_Display',_serif] text-[#facc15] text-5xl md:text-6xl font-bold mb-4" data-id="element-107">
              $6.900 ARS
            </p>
            <div className="inline-block bg-[#facc15] rounded-full py-2 px-6 mb-6" data-id="element-108">
              <p className="font-['Montserrat',_sans-serif] text-[#1a1a1a] font-extrabold text-sm md:text-base uppercase" data-id="element-109">
                Ahorrá $83.000 (92% OFF)
              </p>
            </div>

            <div className="flex justify-center gap-8 mb-8" data-id="element-110">
              <div className="text-center" data-id="element-111">
                <p className="font-['Montserrat',_sans-serif] text-white text-base md:text-lg" data-id="element-112">
                  🔒 Compra
                  <br data-id="element-113" />
                  Protegida
                </p>
              </div>
              <div className="text-center" data-id="element-114">
                <p className="font-['Montserrat',_sans-serif] text-white text-base md:text-lg" data-id="element-115">
                  ⚡ Acceso
                  <br data-id="element-116" />
                  24/7
                </p>
              </div>
            </div>

            <div className="bg-[#1a1f2e] rounded-xl p-6 space-y-5 text-left border border-[#333d52]" data-id="element-117">
              <div className="flex items-start gap-3" data-id="element-118">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-119">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-120">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-121" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-122">
                  Ebook Central{' '}
                  <span className="font-bold" data-id="element-123">Viandas Rentables</span>
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-124">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-125">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-126">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-127" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-128">
                  <span className="font-bold" data-id="element-129">Kit Pro 7x1</span> (Herramientas
                  Editables)
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-130">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-131">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-132">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-133" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-134">
                  <span className="font-bold" data-id="element-135">10 Bonos Exclusivos</span>de
                  Regalo
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-136">
                <div className="w-6 h-6 rounded-full bg-[#4caf50] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-137">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" data-id="element-138">
                    <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-139" />
                  </svg>
                </div>
                <p className="font-['Montserrat',_sans-serif] text-white text-base" data-id="element-140">
                  Acceso <span className="font-bold" data-id="element-141">De Por Vida</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Precio Congelado Card + Countdown */}
      <div className="bg-[#2d5a1e] px-4 md:px-8 pb-8" data-id="element-142">
        <div className="max-w-[500px] mx-auto" data-id="element-143">
          <div className="bg-[#232a3b] rounded-2xl p-8 text-center border border-[#333d52]" data-id="element-144">
            <p className="font-['Montserrat',_sans-serif] text-white font-extrabold text-base md:text-lg uppercase mb-3" data-id="element-145">
              ⚠️ ⚠️ PRECIO CONGELADO POR TIEMPO LIMITADO
            </p>
            <p className="font-['Montserrat',_sans-serif] text-[#ccc] text-sm md:text-base mb-6" data-id="element-146">
              La inflación sube, pero hoy congelamos el precio de tu futuro
              negocio.
            </p>

            <div className="flex justify-center gap-3 mb-6" data-id="element-147">
              {[{
              value: pad(days),
              label: 'DÍAS'
            }, {
              value: pad(hours),
              label: 'HORAS'
            }, {
              value: pad(minutes),
              label: 'MIN'
            }, {
              value: pad(seconds),
              label: 'SEG'
            }].map((item, i) => <div key={i} className="bg-[#1a1f2e] border border-[#4caf50] rounded-lg px-4 py-3 min-w-[65px]" data-id="element-148">
                  <p className="font-['Montserrat',_sans-serif] text-[#4caf50] text-2xl md:text-3xl font-bold" data-id="element-149">
                    {item.value}
                  </p>
                  <p className="font-['Montserrat',_sans-serif] text-[#888] text-xs uppercase" data-id="element-150">
                    {item.label}
                  </p>
                </div>)}
            </div>

            <button className="w-full bg-[#facc15] hover:bg-[#e6b800] text-[#1a1a1a] font-['Montserrat',_sans-serif] font-extrabold text-base md:text-lg uppercase py-4 md:py-5 rounded-full transition-colors shadow-lg animate-pulse-scale-final" data-id="element-151">
              ¡NO DEJES PASAR ESTA OPORTUNIDAD!
            </button>
          </div>
        </div>
      </div>

      {/* CTA Buttons + Badges */}
      <div className="bg-[#2d5a1e] px-4 md:px-8 pb-16" data-id="element-152">
        <div className="max-w-[700px] mx-auto" data-id="element-153">
          {/* Green CTA */}
          <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#4caf50] hover:bg-[#43a047] text-white font-['Montserrat',_sans-serif] font-bold text-base md:text-lg uppercase py-4 md:py-5 rounded-full transition-colors shadow-[0_4px_16px_rgba(76,175,80,0.4)] mb-6 animate-pulse-scale-final text-center" data-id="element-154">
            ¡SÍ, QUIERO MI ACCESO AHORA!
          </a>

          {/* 558 personas badge */}
          <div className="flex justify-center mb-5" data-id="element-155">
            <div className="bg-[#3a6e2a] rounded-full py-3 px-6 animate-pulse-scale-final" data-id="element-156">
              <p className="font-['Montserrat',_sans-serif] text-white font-bold text-sm md:text-base" data-id="element-157">
                ⚡ 558 emprendedoras se están uniendo ahora.
              </p>
            </div>
          </div>

          {/* La demanda es muy alta */}
          <p className="font-['Montserrat',_sans-serif] text-[#facc15] font-bold text-base md:text-lg text-center uppercase mb-5" data-id="element-158">
            ⚡ LA DEMANDA ES MUY ALTA
          </p>

          {/* Red CTA */}
          <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#e74c3c] hover:bg-[#c0392b] text-white font-['Montserrat',_sans-serif] font-bold text-base md:text-lg uppercase py-4 md:py-5 rounded-full transition-colors shadow-[0_4px_16px_rgba(231,76,60,0.4)] mb-8 animate-pulse-scale-final text-center" data-id="element-159">
            ❗ ASEGURAR MI PRECIO Y BONOS AHORA
          </a>

          {/* Payment methods */}
          <div className="flex justify-center mb-6" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/2SBRG1SWUt1Bfe66mBS484/Captura_de_pantalla_2026-04-30_a_las_9.04.43_p._m..png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="max-w-[400px] w-full h-auto rounded-xl" data-id="element-161" />
          </div>

          {/* MercadoLider badge */}
          <div className="flex justify-center" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/1XMJUMd4s9ViDsoYjjaH6m/Captura_de_pantalla_2026-04-30_a_las_9.04.51_p._m..png" alt="MercadoLíder Platinum - 145121 ventas" className="max-w-[400px] w-full h-auto rounded-xl" data-id="element-163" />
          </div>
        </div>
      </div>
    </section>;
}